import React, { useEffect, useState } from "react";
import ProductsCard from "../card/ProductsCard";
import ProductCardDesc from "../card/ProductCardDesc";
import { httpReauest } from "../../../utils/httpRequest";
import Loading from "../Loading";

const BestProducts = ({ brand }) => {
  const [loading, setLoading] = useState();
  const [vehcledata, setvehcledata] = useState();

  useEffect(() => {
    getData();
  }, []);

  async function getData(params) {
    setLoading(true);
    await httpReauest("GET", "/vehicle/best" + `?brand=${brand}`, {}, {}).then(
      ({ data }) => {
        setvehcledata(data?.data);
      }
    );
    setLoading(false);
  }
  return (
    <>
      {" "}
      <h3 className="text-[20px] font-[700]">پر بازدیدترین خودرو ها</h3>
      <div className="grid grid-cols-3 xl:grid-cols-4 gap-5 mt-4">
        {loading ? (
          <Loading />
        ) : (
          vehcledata?.map((e) => (
            <span>
              <ProductCardDesc data={e} />
            </span>
          ))
        )}
      </div>
    </>
  );
};

export default BestProducts;
